import { Input, Output, EventEmitter, Directive, TemplateRef, ContentChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import {
  DeleteDialogDataWithTemplate,
  DeleteDialogComponent,
  DeleteDialogAction,
} from './delete-dialog.component';

@Directive({
  selector: 'delete-dialog',
  exportAs: 'deleteDialog',
})
export class DeleteDialogDirective {
  @Input() deleteText: string = 'Delete';
  @Input() secondaryText: string = '';
  @Input() noText: string = 'Cancel';
  @Input() header: string = 'Set header';
  @Input() width: number;
  @Input() onDelete: () => Promise<boolean>;
  @Input() onSecondary: () => Promise<boolean>;
  @Input() minHeightPx?: number;
  //Whether the user can use escape or clicking on the backdrop to close the modal
  @Input() disableClose: boolean;
  @Input() formGroup: FormGroup;
  @Output() onClose = new EventEmitter<DeleteDialogAction>();

  @ContentChild(TemplateRef) template: TemplateRef<any>;
  constructor(private dialog: MatDialog) {}

  openModal = (
    configOverrides: Partial<DeleteDialogDataWithTemplate> = {}
  ): MatDialogRef<DeleteDialogComponent, DeleteDialogAction> =>
    this.dialog.open(DeleteDialogComponent, this.buildConfig(configOverrides));

  private buildConfig = (
    configOverrides: Partial<DeleteDialogDataWithTemplate>
  ): MatDialogConfig<DeleteDialogDataWithTemplate> => ({
    width: `${this.width ?? 683}px`,
    maxWidth: '95vw',
    disableClose: this.disableClose ?? true,
    autoFocus: 'modal',
    data: {
      header: this.header,
      deleteText: this.deleteText,
      secondaryText: this.secondaryText,
      noText: this.noText,
      template: this.template,
      formGroup: this.formGroup,
      onDelete: this.onDelete,
      onSecondary: this.onSecondary,
      ...configOverrides,
    },
  });

  //called from HTML ex. (click)="infoModal.open()"
  open = (
    configOverrides: Partial<DeleteDialogDataWithTemplate> = {}
  ): Promise<DeleteDialogAction> =>
    this.openModal(configOverrides)
      .afterClosed()
      .toPromise()
      .then((closeType: DeleteDialogAction) => {
        this.onClose.emit(closeType);
        return closeType;
      });

  close() {
    this.dialog.closeAll();
  }
}
